import { AxiosPromise } from "axios";
import { dashboardApiConfig, ops } from "./config";
import { BrandTemplateResourceApi } from "../generated/dashboard-client";
import { env } from "../env/env";
import { isStageEnv } from "../util/constants";

export type BrandTemplateProductType =
  | "MENU_CUSTOM_SIZE"
  | "MENU_LETTER"
  | "MENU_LEGAL"
  | "MENU_TABLOID"
  | "MENU_A4"
  | "DMB_LANDSCAPE"
  | "DMB_PORTRAIT";

export type BrandTemplateSizeUnit = "IN" | "CM" | "MM" | "PX";

export interface BrandTemplateDto {
  id?: string;
  brandKitId: string;
  name: string;
  productType: BrandTemplateProductType;
  createdById?: number | null;
  updatedById?: number | null;
  createdDate?: string;
  updatedDate?: string;
  width?: number | null;
  height?: number | null;
  sizeUnit?: BrandTemplateSizeUnit | null;
  lastEditorName?: string | null;
}

const api = new BrandTemplateResourceApi(dashboardApiConfig);

function timberUrl(path: string): string {
  const prefix = !isStageEnv ? env.basePath : "";
  return `${prefix}${env.timberContextPath}${path}`;
}

function timberHeaders(): HeadersInit {
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.getItem("tkn"),
  };
}

const BrandTemplateApi = {
  listByBrandKit(brandKitId: string): AxiosPromise<BrandTemplateDto[]> {
    return api.listByBrandKit(brandKitId, ops()) as unknown as AxiosPromise<BrandTemplateDto[]>;
  },
  async listByLocation(locationId: number): Promise<BrandTemplateDto[]> {
    const resp = await fetch(`${env.apiPath}/brand-templates/by-location?locationId=${locationId}`, {
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("tkn"),
      },
    });
    if (!resp.ok) throw new Error(`Failed to load brand templates (${resp.status})`);
    return (await resp.json()) as BrandTemplateDto[];
  },
  get(id: string): AxiosPromise<BrandTemplateDto> {
    return api.get1(id, ops()) as unknown as AxiosPromise<BrandTemplateDto>;
  },
  removeFromBrandTemplates(id: string): AxiosPromise<void> {
    return api.removeFromBrandTemplates(id, ops()) as unknown as AxiosPromise<void>;
  },
  rename(id: string, name: string): Promise<Response> {
    return fetch(timberUrl(`/api/designs/${id}/name`), {
      method: "PUT",
      headers: timberHeaders(),
      body: JSON.stringify({ name }),
    });
  },
  copy(brandKitId: string, fromDesignId: string): Promise<Response> {
    return fetch(timberUrl(`/api/brand-templates`), {
      method: "POST",
      headers: timberHeaders(),
      body: JSON.stringify({ brandKitId, fromDesignId }),
    });
  },
  delete(id: string): Promise<Response> {
    return fetch(timberUrl(`/api/designs/${id}`), {
      method: "DELETE",
      headers: timberHeaders(),
    });
  },
};

export default BrandTemplateApi;
